<template>
  <h1
    :class="item.classes"
    v-html="item.html"
  ></h1>
</template>

<script>
export default {
  name: 'NodeHeading',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
}
</script>
